import { createRoot } from 'react-dom/client';
import App from './App';
import { installCsrfFetchInterceptor } from './lib/csrf';
import { initScribeSentry } from './lib/sentry';
import './index.css';

// Initialize Sentry as early as possible
initScribeSentry();
// Attach the session CSRF token to all same-origin mutating requests
installCsrfFetchInterceptor();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
createRoot(rootElement).render(<App />);
